import React from "react";
import "./index.css";
import { TierKey } from "../../redux/allocationService";
import { TIER_LABELS } from "../../utility/Utility";

interface TierBadgeProps {
  tier: TierKey;
}

export const TierBadge: React.FC<TierBadgeProps> = ({ tier }) => (
  <span className={`packs-tier-badge packs-tier-badge--${tier}`}>
    {TIER_LABELS[tier]}
  </span>
);